import type { ComponentSchema } from '../../../../../schema-types'
import { SECTION_STYLE_FIELDS } from './_fields'

/** Brand logos on rounded white chips, as a grid or a ticker; empty uses the store's brands. */
export const schema: ComponentSchema = {
  type: 'brands',
  label: 'Brands',
  description: 'Brand logos as a grid of tiles or a scrolling ticker; leave empty to show the store\'s brands.',
  supportedPages: ['home', 'shop', 'categories'],
  variants: [{ id: 'v1', label: 'Logo chips' }],
  commonFields: [
    { key: 'title', label: 'Title', type: 'string', default: 'Brands kids love' },
    {
      key: 'layout',
      label: 'Layout',
      type: 'select',
      options: [{ label: 'Grid', value: 'grid' }, { label: 'Ticker', value: 'ticker' }],
      default: 'grid',
    },
    {
      key: 'items',
      label: 'Brands',
      type: 'array',
      itemSchema: [
        { key: 'logo', label: 'Logo', type: 'image' },
        { key: 'name', label: 'Name', type: 'string' },
        { key: 'link', label: 'Link', type: 'string' },
      ],
    },
    ...SECTION_STYLE_FIELDS,
  ],
}
